const zh = {
  CreativeTasks: {
    TitleTeacher: "创意任务",
    TitleStudent: "创意任务",
    UpdateTaskTeacher: "保存",
    SubmitTaskTeacher: "将结果发送给学生",
    UpdateTaskStudent: "保存草稿",
    SubmitTaskStudent: "保存并提交审核",
    AnswerHeaderStatistics:
      "问题：{{questions}} | 符号：{{symbols}} | 单词：{{words}} | 句子：{{sentenses}}",
    QuestionsAndComments: "问题和评论：",
    HoverForDisplay: "悬停显示：",
    CheckingHistory: "检查历史记录",
    CurrentVersion: "当前版本",
    TeacherComment: "教师对作业的评论：",
    CommentPlaceholder: "您可以在这里对作业留言",
    SaveCorrection: "保存",
    CancelCorrection: "取消",
    Grammar: "语法",
    Lexical: "词汇",
    Comment: "评论",
    ErrorRangeFilled: "您已为所选范围填写了所有错误类型",
    SaveError: "保存",
    GrammarErrorTitle: "语法",
    ResultTitle: "创意任务结果",
    Student: "学生",
    Teacher: "教师",
    CurrentVersionTime: "当前版本：{{time}}",
    TaskText: "任务",
    HasErrors: "有错误",
    WithoutErrors: "无错误完成",
    UpdateSavedTeacher: "您的更改已保存",
    UpdateSavedStudent: "您的草稿已保存",
    UpdateSubmitedTeacher: "检查结果已发送",
    UpdateSubmitedStudent: "您的修改已发送",
    Checking: "审核中",
    Done: "已完成",
    FixStudent: "修改",
    FixTeacher: "有错误",
    CheckingTime: "审核中 • {{time}}",
    DoneTime: "已完成 • {{time}}",
    TeacherName: "教师：{{name}}",
    StudentName: "学生：{{name}}",
    AllStatuses: "所有状态",
    Checked: "已检查",
    NewCheck: "审核中",
    Processing: "处理中",
    StudentSearch: "搜索学生",
    TeacherSearch: "搜索教师",
    EmptyList: "当前没有合适的任务",
    TaskSubtitle: '单元 "{{unit}}" • "{{part}}" • 练习 "{{exercise}}"',
    GoToExercise: "前往练习",
  },
};

export default zh;
